import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ValidatorType } from '@shared/models/enums/validator-type.enum';
import { Calendar } from '@shared/models/question-types/calendar';
import { ValidatorComponent } from '../../validator/validator.component';
import { QuestionBaseComponent } from '../question-base/question-base.component';

@Component({
  selector: 'app-locale-date',
  imports: [CommonModule, QuestionBaseComponent, ValidatorComponent],
  templateUrl: './locale-date.component.html',
  styleUrls: ['./locale-date.component.scss'],
})
export class LocaleDateComponent implements AfterViewInit {
  @Input({ required: true }) question!: Calendar;
  @Input({ required: true }) control!: AbstractControl;
  @Input() isFirstQuestion: boolean = false;
  public readonly ValidatorType = ValidatorType;
  public value: string = '';

  public get inputId(): string {
    return this.question?.id ?? 'date-input';
  }

  public get inputAriaLabel(): string {
    const title: any =
      (this.question as any).title || (this.question as any).label;
    return title ? String(title) : 'Date';
  }

  public get validatorId(): string {
    return `${this.inputId}-error`;
  }

  ngAfterViewInit(): void {
    if (this.control.value) {
      try {
        const initialDate = new Date(this.control.value);
        if (!isNaN(initialDate.getTime())) {
          this.value = this.formatDateForInput(initialDate);
        }
      } catch (error) {
        console.error(
          'Error parsing initial date value:',
          this.control.value,
          error,
        );
        this.value = '';
      }
    }
  }

  onDateChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const selectedValue = inputElement.value;
    this.control.markAsTouched();
    if (selectedValue) {
      const date = new Date(`${selectedValue}T00:00:00Z`);
      this.setAndEmitISOString(date);
    } else {
      this.control.setValue(null);
    }
  }

  private setAndEmitISOString(date: Date): void {
    if (date && !isNaN(date.getTime())) {
      this.control.setValue(date.toISOString());
    }
  }

  private formatDateForInput(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
